export enum eRounding {
  Cents = 'Cents',
  Ones = 'Ones',
  DownOne = 'DownOne',
  UpOne = 'UpOne',
  Hundreds = 'Hundreds',
  Thousands = 'Thousands',
  FiveThousands = 'FiveThousands',
  TenThousands = 'TenThousands',
  TwentyThousands = 'TwentyThousands',
  None = 'None',
}
